import React from 'react';
import OnboardingTour from '../../shared/onboarding/OnboardingTour';

export default function ProjectsListPageTour() {
  return (
    <OnboardingTour
      tourId="PropertiesList"
      steps={[
        {
          selector: '[data-testid="projects-status-filter"]',
          content: 'View and manage Active, Closed and Archived Transactions.',
        },
        {
          selector: '[data-testid="projects-filter-button"]',
          content: 'Display transactions based on Team Member, Type or only those with Past Due Tasks.',
        },
        {
          selector: '[data-testid="projects-aggregated-info"]',
          content: 'Get a quick snapshot of upcoming Commission income',
        },
        {
          selector: 'th[data-testid="next-key-date-field"]',
          content: 'Easily see the next important milestone in each transaction.',
        },
        {
          selector: '[data-testid="closing-date-field"]',
          highlightedSelectors: ['[data-testid="closing-date-field"]', '[data-testid="commission-field"]'],
          content: 'Sort by any column using data that is pulled in from the Transaction Details page.',
        },
      ]}
    />
  );
}
